import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { RegistrationFieldsApi } from '../../../apis/RegistrationFieldsApi/RegistrationFieldsApi.ts';
import { IRegistrationFieldConfigItem } from '../RegistrationFields.ts';

interface SaveRegistrationFieldsVars {
    facilityId: number;
    config: IRegistrationFieldConfigItem[];
}

export function useSaveFacilityRegistrationFields() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation<void, AppMedError, SaveRegistrationFieldsVars>({
        mutationKey: [QueryKeys.facilityRegistrationFields, 'save'],
        mutationFn: ({ facilityId, config }) =>
            RegistrationFieldsApi.save(facilityId, { config }),
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({
                queryKey: [QueryKeys.facilityRegistrationFields, vars.facilityId],
            });
            notifications.show({
                color: 'green',
                message: t('registrationFields.admin.saved'),
            });
        },
        onError: (err) => {
            notifications.show({ color: 'red', message: err.message });
        },
    });
}
